const inFlightRequests = new Map();

export const fetchFlowVariablesOnce = (flowId, requestFactory) => {
  if (!flowId) {
    return {
      isNewRequest: false,
      promise: Promise.resolve(null),
    };
  }

  if (inFlightRequests.has(flowId)) {
    return {
      isNewRequest: false,
      promise: inFlightRequests.get(flowId),
    };
  }

  const requestPromise = requestFactory().finally(() => {
    inFlightRequests.delete(flowId);
  });

  inFlightRequests.set(flowId, requestPromise);

  return {
    isNewRequest: true,
    promise: requestPromise,
  };
};

export const invalidateFlowVariablesCache = (flowId = null) => {
  if (!flowId) {
    inFlightRequests.clear();
    return;
  }

  inFlightRequests.delete(flowId);
};
